import { CalendarEventListProps } from '@factorialco/f0-react/dist/experimental'

import { oneOnOneMeetingNormalizer } from 'modules/one_on_ones/lib/calendarEvent/normalizer'
import { companyEventCalendarEventNormalizer } from 'modules/posts/lib/calendarEvent/normalizer'
import { shiftCalendarEventNormalizer } from 'modules/shift_management/lib/calendarEvent/normalizer'
import {
  companyHolidayNormalizer,
  leaveCalendarEventNormalizer,
} from 'modules/timeoff/lib/calendarEvent/normalizer'
import { trainingSessionCalendarEventNormalizer } from 'modules/trainings/lib/calendarEvent/normalizer'

const normalizers = [
  shiftCalendarEventNormalizer,
  leaveCalendarEventNormalizer,
  trainingSessionCalendarEventNormalizer,
  companyEventCalendarEventNormalizer,
  companyHolidayNormalizer,
  oneOnOneMeetingNormalizer,
]

type Normalizer = (typeof normalizers)[number]

type UnionToIntersection<U> = (U extends unknown ? (x: U) => void : never) extends (
  x: infer R
) => void
  ? R
  : never

export type Item = Parameters<Normalizer>[0]

const normalizersByTypename: Record<NonNullable<Item['__typename']>, Normalizer> = {
  ShiftManagementShift: shiftCalendarEventNormalizer,
  TimeoffLeave: leaveCalendarEventNormalizer,
  TrainingsSession: trainingSessionCalendarEventNormalizer,
  PostsPost: companyEventCalendarEventNormalizer,
  HolidaysCompanyHoliday: companyHolidayNormalizer,
  OneOnOnesMeetingEdge: oneOnOneMeetingNormalizer,
}

export const normalizeItem: (item: Item) => CalendarEventListProps['events'][number] | undefined = (
  item
) => {
  if (!item.__typename) return

  const normalizer = normalizersByTypename?.[item.__typename]
  if (!normalizer) return

  // eslint-disable-next-line no-type-assertion/no-type-assertion
  return normalizer(item as UnionToIntersection<Parameters<typeof normalizer>[0]>)
}
